import React, { Component } from 'react';
import PageHelmet from '../../organisms/PageHelmet';
import AttendanceStatus from '../../organisms/AttendanceStatus';
import PeopleList from '../../organisms/PeopleList';
import './People.css';

class People extends Component {

  render() {
    return (
      <div className="People">

        <PageHelmet pageTitle="Staggers" />

        <h4> My Attendance </h4>
        <AttendanceStatus />

        <h4> Responses </h4>
        <PeopleList />

      </div>
    );
  }

}

export default People;



// WEBPACK FOOTER //
// ./src/component/pages/People/index.js